<template>
  <mi-dialog
    :model-value="confirmationModal"
    :custom-design-dialog="true"
    class="send-to-search-confirmation-dialog"
    no-backdrop-dismiss
  >
    <div class="send-to-search-confirmation-dialog-wrapper">
      <div class="send-to-search-confirm-header-wrapper">
        <div class="send-to-search-confirm-btn">
          <h3 class="q-mt-none q-mb-none send-to-search-confirmation-header"> Send this collection to search? </h3>
          <div class="send-to-search-confirmation-close-icon">
            <mi-btn
              icon="close"
              icon-type
              icon-size="21px"
              fab
              flat
              @click="$emit('update:confirmationModal', false)"
            ></mi-btn>
          </div>
        </div>

        <p class="q-mb-xl">
          There is currently a selection in search which will be overwritten by this one if you choose to continue.
        </p>
      </div>

      <div class="send-to-search-confirmation-wrapper">
        <mi-btn flat @click="$emit('update:confirmationModal', false)"> Cancel </mi-btn>
        <mi-btn @click="handleConfirm"> Yes, send to search </mi-btn>
      </div>
    </div>
  </mi-dialog>
</template>

<script>
  export default {
    name: 'SendToSearchConfirmationModal',
    props: {
      confirmationModal: {
        type: Boolean,
        required: true
      },
      selectedRow: {
        type: Object,
        required: true
      }
    },
    emits: ['update:confirmationModal', 'confirm'],
    setup(props, { emit }) {
      const handleConfirm = () => {
        emit('confirm', props.selectedRow)
        emit('update:confirmationModal', false)
      }

      return {
        handleConfirm
      }
    }
  }
</script>

<style lang="scss" scoped>
  // stylelint-disable declaration-no-important
  .send-to-search-confirmation-dialog-wrapper {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .send-to-search-confirm-header-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .send-to-search-confirm-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .send-to-search-confirmation-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .send-to-search-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
  }
</style>
